import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import SEO from "@/components/SEO";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import Arrow from "@/assets/icons/arrow-top-right.svg";
import vector from "@/assets/blog/blog-vector.png";
import localizePath from "@/functions/localizePath";

export default function CaseStudiesPage({ locale = "en", items }) {
  return (
    <>
      <SEO
        path={localizePath("/case-studies", locale)}
        title="Case Study | Lawrence Harvey"
        description="We take our clients hiring needs as our own"
      />
      <main
        id="CaseStudiesPage"
        className="bg-purple h-full pt-[60px] md:pt-[140px]"
      >
        <img
          src={vector ?? ""}
          alt="vector"
          className="absolute top-0 left-0"
        />
        <div className="container relative z-50 job_search">
          <h1 className="text-[40px]/[50px] py-20 md:text-6xl lg:text-[100px] max-w-[957px]">
            <CustomSourceFlowText
              title="Case Studies"
              path="dynamic1.case.heading1"
              locale={locale}
            />
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 gap-y-4">
            {items.map((item) => (
              <div key={item.id}>
                <a
                  href={localizePath(`/case-studies/${item.url_slug}`, locale)}
                >
                  <div className="relative z-[100] group/item cursor-pointer">
                    <div className="bg-blue h-12 w-12 hidden group-hover/item:flex items-center justify-center absolute right-0 bottom-0 p-[6px] z-10">
                      <Arrow className="[&>path]:fill-purple [&>path]:stroke-purple" />
                    </div>
                    <img
                      src={item?.logo}
                      alt="hiring card"
                      className="w-full group-hover/item:opacity-60"
                    />
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}

export async function getStaticProps() {
  const items = (await Collection("case_studies")).getItems();

  return { props: { items } };
}
